const COLOR_PALETTE = Object.freeze({
  White: "#FFFFFF",
  Black: "#000000",
  Pink: "#FF83A8",
  Transparent: "rgba(255, 255, 255, 0)",
});

export default COLOR_PALETTE;
